import { render, staticRenderFns } from "./turnover.vue?vue&type=template&id=65d1d0e2&scoped=true&"
import script from "./turnover.vue?vue&type=script&lang=js&"
export * from "./turnover.vue?vue&type=script&lang=js&"
import style0 from "./turnover.vue?vue&type=style&index=0&id=65d1d0e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d1d0e2",
  null
  
)

export default component.exports